<template>
  <div v-if="!isMobile()">
    <div class="page-header clear-filter" filter-color="black2">
      <div class="page-header-image2 bg">
        <video
          id="pc-bganimation"
          autoplay=""
          loop=""
          preload="auto"
          muted="muted"
        >
          <source src="/video/bg_pc.mp4?v=20220512" type="video/mp4" />
        </video>
      </div>
      <div
        id="top"
        style="
          position: absolute;
          left: 0px;
          top: 0px;
          width: 100vw;
          height: 100vh;
        "
      >
        <div
          class="d-flex flex-column justify-content-lg-around"
          style="margin-top: 0px"
        >
          <div style="margin: 10vh auto 0px; width: 25%">
            <img v-lazy="'/img/logo.png'" style="width: 100%" />
          </div>
          <!-- <div
            v-if="eventStarted == false"
            style="
              margin: 0 auto 0px;
              width: 626px;
              height: 183px;
              background-image: url('/img/mysterybox_main_bnr.png');
              background-size: contain;
              background-repeat: no-repeat;
            "
          >
            <div
              style="
                margin-top: 19.2%;
                margin-right: 20%;
                font-family: Poppins;
                font-size: 16px;
                line-height: 2;
                letter-spacing: -0.4px;
                text-align: right;
                color: #00ffe4;
              "
            >
              {{String(day).padStart(2, '0')}}d {{String(hour).padStart(2, '0')}}h:{{String(min).padStart(2, '0')}}m:{{String(sec).padStart(2, '0')}}s
            </div>
          </div>
          <div
            v-else
            @click="goEvent()"
            style="
              margin: 0 auto 0px;
              width: 626px;
              height: 183px;
              background-image: url('/img/mysterybox_main_bnr02.png');
              background-size: contain;
              background-repeat: no-repeat;
              cursor: pointer;
            "
          >
          </div> -->
          <!-- <div v-if="saleStatus == false" class="DR_Sale-time-box" v-bind:style="{ zoom: getZoomLevel() }">
            <div class="DR_Sale-time-bg"></div>
            <div class="line"></div>
            <div class="DRAGO-GENESIS-SALE-HOME">DRAGO GENESIS SALE</div>
            <div class="COMING-SOON">COMING SOON</div>
            <div class="--timer-box">
              <div class="--timer-bg"></div>
              <div class="timer-box" style="left: 40px;">
                <div class="time">{{String(day).padStart(2, '0')}}</div>
                <div class="time_head">DAYS</div>
              </div>
              <div class="timer-box" style="left: 190px;">
                <div class="time">{{String(hour).padStart(2, '0')}}</div>
                <div class="time_head">HOUR</div>
              </div>
              <div class="timer-box" style="left: 340px;">
                <div class="time">{{String(min).padStart(2, '0')}}</div>
                <div class="time_head">MIN</div>
              </div>
              <div class="timer-box" style="left: 490px;">
                <div class="time">{{String(sec).padStart(2, '0')}}</div>
                <div class="time_head">SEC</div>
              </div>
              <div class="timer-box" style="left: 265px;"><div class="time">:</div></div>
              <div class="timer-box" style="left: 415px;"><div class="time">:</div></div>
            </div>            
          </div>
          <div v-if="saleStatus == true && saleHover == false" class="DR_Sale-time-box-start" v-bind:style="{ zoom: getZoomLevel() }" v-on:mouseover="saleHover=true" v-on:mouseout="saleHover=false" @click="goGenesisSale()">
            <div class="DR_Sale-time-bg-start"></div>
            <div class="line-start"></div>
            <div class="DRAGO-GENESIS-SALE-TEXT">
              DRAGO GENESIS SALE
            </div>
            <img src="/img/icon-arrow-normal.png" style="position: absolute; right: 42px; top: calc(50% - 10px);" />
          </div>
          <div v-if="saleStatus == true && saleHover == true" class="DR_Sale-time-box-start-hover" v-bind:style="{ zoom: getZoomLevel() }" v-on:mouseover="saleHover=false" v-on:mouseout="saleHover=false" @click="goGenesisSale()">
            <div class="DR_Sale-time-bg-start-hover"></div>
            <div class="line-start-hover"></div>
            <div class="DRAGO-GENESIS-SALE-TEXT-HOVER">
              DRAGO GENESIS SALE
            </div>
            <img src="/img/icon-arrow-hover.png" style="position: absolute; right: 42px; top: calc(50% - 10px);" />
          </div>
          <div style="width: 385px;
          margin-left: calc(50% - 192px);
          margin-top: 50px;
  height: 60px;
  border-radius: 30px;
  border: solid 1px #5b6a9f;
  background-color: #0d6eff;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  line-height: 2.63;
  letter-spacing: -0.4px;
  text-align: center;
  padding-top: 8px;
  cursor: pointer;
  color: #fff;" @click="goAboutGenesis()">
            DRAGO GENESIS Guide
          </div> -->
          <div style="margin: 0 auto; width: 20%">
            <!-- <img
              v-lazy="'/img/event/img-lokaday-02.png'"
                style="
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 10px;
                  cursor: pointer;
                  width: 100%;
                "
                @click="goEvent()"
              /> -->
            <img
              v-lazy="'/img/btn_start.png'"
              v-if="$i18n.locale != 'ko'"
              style="
                margin: auto;
                margin-top: 20px;
                margin-bottom: -20px;
                cursor: pointer;
                width: 100%;
              "
              @click="goGame()"
            />
            <div style="margin: auto; margin-top: 40px; width: 100%">
              <img
                v-lazy="'/img/btn_ios.png'"
                style="float: left; cursor: pointer; width: 48%"
                @click="goAppstore()"
              />
              <img
                v-lazy="'/img/btn_google.png'"
                style="float: right; margin: auto; cursor: pointer; width: 48%"
                @click="goPlaystore()"
              />
            </div>
            <img
              v-lazy="'/img/btn_land.png'"
              style="margin: auto; margin-top: 3%; cursor: pointer; width: 100%"
              @click="goLand()"
            />
            <img
              v-lazy="'/img/btn-dst-dashboard.png'"
              style="margin: auto; margin-top: 3%; cursor: pointer; width: 100%"
              @click="goDSTDashboard()"
            />
          </div>
        </div>
      </div>
    </div>
    <trailer-section></trailer-section>
    <blockchain-section></blockchain-section>
    <partners-section></partners-section>
  </div>
  <div v-else>
    <div class="page-header clear-filter" filter-color="black">
      <parallax
        class="page-header-image2"
        style="background-image: url('/img/img_m.png')"
      ></parallax>
      <div class="container" id="top">
        <div class="d-flex flex-column justify-content-lg-around">
          <img v-lazy="'/img/logo.png'" style="margin-top: 20px" />
          <div style="width: 60%; margin: auto">
            <div
              style="
                margin: auto;
                margin-top: 10px;
                width: 100%;
                cursor: pointer;
              "
            >
              <img
                v-lazy="'/img/btn_ios.png'"
                style="cursor: pointer; width: 100%"
                @click="goAppstore()"
              />
              <img
                v-lazy="'/img/btn_google.png'"
                style="margin-top: 4%; cursor: pointer; width: 100%"
                @click="goPlaystore()"
              />
            </div>
            <img
              v-lazy="'/img/btn_land_m.png'"
              style="margin-top: 4%; cursor: pointer; width: 100%"
              @click="goLand()"
            />
          </div>
        </div>
      </div>
    </div>
    <trailer-section></trailer-section>
    <blockchain-section></blockchain-section>
    <partners-section></partners-section>
  </div>
</template>
<script>
import { Parallax, Modal, Button } from "@/components";
import TrailerSection from "./components/TrailerSection";
import GameSection from "./components/GameSection";
import BlockchainSection from "./components/BlockchainSection";
import PartnersSection from "./components/PartnersSection";
import { Popover } from "element-ui";
import FlipCountdown from "./components/FlipCountdown";
import VueScreenSize from "vue-screen-size";
import config from "../config.js";
import axios from "axios";

export default {
  name: "index",
  bodyClass: "index-page",
  mixins: [VueScreenSize.VueScreenSizeMixin],
  components: {
    [Button.name]: Button,
    [Popover.name]: Popover,
    Parallax,
    Modal,
    TrailerSection,
    GameSection,
    BlockchainSection,
    PartnersSection,
    FlipCountdown,
  },
  data() {
    return {
      width: 0,
      height: 0,
      startTime: new Date("2023-03-01 00:00:00Z").getTime(),
      day: 0,
      hour: 0,
      min: 0,
      sec: 0,
      saleStatus: false,
      eventStarted: false,
      saleHover: false
    };
  },
  computed: {},
  mounted: async function () {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    this.checkTimer();
    setInterval(() => {
      this.checkTimer();
    }, 1000);
  },
  beforeDestroy: function () {},
  methods: {
    checkTimer() {
      let now = new Date().getTime();
      if (now > this.startTime) {
        this.eventStarted = true;
        this.day = 0;
        this.hour = 0;
        this.min = 0;
        this.sec = 0;
        this.saleStatus = true;
      } else {
        this.eventStarted = false;
        this.saleStatus = false;
        let remain = this.startTime - now;
        this.day = Math.floor(remain / (24 * 60 * 60 * 1000));
        remain -= this.day * (24 * 60 * 60 * 1000);
        this.hour = Math.floor(remain / (60 * 60 * 1000));
        remain -= this.hour * (60 * 60 * 1000);
        this.min = Math.floor(remain / (60 * 1000));
        remain -= this.min * (60 * 1000);
        this.sec = Math.floor(remain / 1000);
      }
    },
    getZoomLevel() {
      return this.width / 1920.0;
    },
    handleResize(event) {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    goGame: async function () {
      let url = "//play.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goEvent() {
      let url = "/event" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goMarketPlace() {
      let url = "//marketplace.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goAppstore: async function () {
      let url =
        "//apps.apple.com/us/app/league-of-kingdoms/id1523441842" +
        localStorage.urlParam;
      window.open(url, "_blank");
    },
    goPlaystore: async function () {
      let url =
        "//play.google.com/store/apps/details?id=com.nplusent.lok" +
        localStorage.urlParam;
      window.open(url, "_blank");
    },
    goLand: async function () {
      let url = "//land.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goDSTDashboard: async function () {
      let url = "//dst.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goGenesisSale() {
      this.$router.push("/genesis");
    },
    goAboutGenesis: async function () {
      let url =
        "//medium.com/league-of-kingdoms-eng/the-drago-genesis-guide-2278ebd7fb80";
      window.open(url, "_blank");
    },
  },
};
</script>
<style>
video {
  display: block;
  width: 100vw;
  height: 100vh;
  outline: 0;
  object-fit: cover;
}

.DR_Sale-time-box {
  position: relative;
  margin-top: -40px;
  margin-left: calc(50% - 340px);
  width: 680px;
  height: 330px;
}

.DR_Sale-time-box-start {
  cursor: pointer;
  position: relative;
  margin-top: -40px;
  margin-left: calc(50% - 300px);
  width: 600px;
  height: 160px;
}

.DR_Sale-time-bg {
  position: absolute;
  left: 40px;
  top: 0px;
  width: 600px;
  height: 330px;
  padding: 12px;
  opacity: 0.7;
  border-radius: 10px;
  border: solid 0 #000;
  background-color: #202431;
}

.DR_Sale-time-bg-start {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 600px;
  height: 160px;
  opacity: 0.6;
  border-radius: 10px;
  border: solid 0 #000;
  background-color: #202431;
}

.DRAGO-GENESIS-SALE-HOME {
  position: absolute;
  top: 30px;
  left: 0px;
  width: 100%;
  background-image: linear-gradient(to right, #ffa921, #f4ff3f),
    linear-gradient(to bottom, #fff, #fff);
  font-size: 36px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.DR_Sale-time-box-start-hover {
  cursor: pointer;
  position: relative;
  margin-top: -40px;
  margin-left: calc(50% - 300px);
  width: 600px;
  height: 160px;
}

.DR_Sale-time-bg-start-hover {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 600px;
  height: 160px;
  opacity: 0.6;
  border-radius: 10px;
  box-shadow: 0px 10px 10px 0 rgba(0, 0, 0, 0.2);
  border: solid 0 #000;
  background-image: linear-gradient(to right, #00baff, #5b2afa);
}

.COMING-SOON {
  position: absolute;
  top: 80px;
  left: 0px;
  width: 100%;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.63;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.line {
  position: absolute;
  top: 12px;
  left: 52px;
  width: 576px;
  height: 306px;
  opacity: 0.1;
  border-radius: 10px;
  border: solid 1px #fff;
}

.line-start {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 576px;
  height: 136px;
  opacity: 0.1;
  border-radius: 10px;
  border: solid 1px #fff;
}

.line-start-hover {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 576px;
  height: 136px;
  opacity: 0.1;
  border-radius: 10px;
  border: solid 1px #fff;
  background-color: #fff;
}

.--timer-box {
  position: absolute;
  top: 129px;
  left: 0px;
  width: 680px;
  height: 129px;
  padding-left: 40px;
}

.--timer-bg {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 680px;
  height: 129px;
  border-radius: 16px;
  opacity: 0.7;
  box-shadow: 0px 10px 10px 0 rgba(0, 0, 0, 0.2);
  border: solid 0 #000;
  background-color: #fff;
}

.timer-box {
  position: absolute;
  top: 25px;
  width: 150px;
  height: 80px;
}

.time {
  width: 100%;
  height: 40px;
  font-family: Poppins;
  text-align: center;
  font-size: 40px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.05;
  letter-spacing: -1px;
  text-align: center;
  color: #202431;
}

.time_head {
  width: 100%;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 3;
  letter-spacing: -0.35px;
  text-align: center;
  color: #202431;
}

.DRAGO-GENESIS-SALE-TEXT {
  position: absolute;
  width: 100%;
  padding-top: 52px;
  background-image: linear-gradient(to right, #00c6ff, #28ff83);
  font-size: 36px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.DRAGO-GENESIS-SALE-TEXT-HOVER {
  position: absolute;
  width: 100%;
  padding-top: 52px;
  font-size: 36px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}
</style>
